export function computeCoverDateDisplay({ mode, year, dateFrom, dateTo } = {}) {
  if (mode === "none") return "";
  if (mode === "range") {
    const a = (dateFrom || "").trim();
    const b = (dateTo || "").trim();
    if (a && b) return `${a} – ${b}`;
    return a || b;
  }
  return (year || "").trim();
}

export function resolveCoverDateMode(mode, year) {
  const current = mode || "year";
  if (current !== "year") return current;
  const match = /^(\d{1,2})([./-])(\d{1,2})\2(\d{4})$/.exec(String(year || "").trim());
  if (!match) return current;
  const day = Number(match[1]), month = Number(match[3]), y = Number(match[4]);
  if (y < 1 || y > 9999) return current;
  const date = new Date(0);
  date.setUTCFullYear(y, month - 1, day);
  date.setUTCHours(0, 0, 0, 0);
  return date.getUTCFullYear() === y && date.getUTCMonth() === month - 1
    && date.getUTCDate() === day ? "date" : current;
}